<script setup lang="ts"></script>

<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_446_81)">
      <path
        d="M18.4232 0H1.49378C0.6639 0 0 0.669456 0 1.42259V18.5774C0 19.4142 0.6639 20 1.49378 20H18.5062C19.3361 20 20 19.3305 20 18.5774V1.42259C19.917 0.669456 19.2531 0 18.4232 0Z"
        fill="#0077B5"
      />
      <path
        d="M2.9882 7.53138H5.97575V17.1548H2.9882V7.53138ZM4.39899 2.76151C5.31185 2.76151 6.14173 3.51464 6.14173 4.51883C6.14173 5.52301 5.39484 6.19247 4.39899 6.19247C3.48613 6.19247 2.65625 5.43933 2.65625 4.43515C2.65625 3.43096 3.48613 2.76151 4.39899 2.76151ZM7.80148 7.53138H10.6231V8.87029C11.038 8.11715 11.9509 7.36402 13.4446 7.36402C16.4322 7.36402 17.0131 9.37238 17.0131 11.9665V17.2385H14.0255V12.5523C14.0255 11.4644 14.0255 10.0418 12.4488 10.0418C10.872 10.0418 10.706 11.2134 10.706 12.4686V17.2385H7.80148V7.53138Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_446_81">
        <rect
          width="20"
          height="20"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>
